var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[(_vm.message)?_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('h1',[_vm._v("Login")]),_c('button',{on:{"click":_vm.socialLogin}},[_vm._v("Login")])])
}
var staticRenderFns = []

export { render, staticRenderFns }